import { convertDate } from "../../utils/cart";
import { addMonths,parse,format } from 'date-fns';

export const groupFilteredData = <T extends { email: string; mobile: string }>(
  rowData: T[]
) => {
  const uniqueEmailMobileMap: {
    [key: string]: T[];
  } = {};
  for (let i = 0; i < rowData.length; ++i) {
    const { email, mobile } = rowData[i];
    if (!email || !mobile) continue;
    const currentKey = `${email.trim()}-${mobile.trim()}`;
    if (uniqueEmailMobileMap[currentKey]) {
      uniqueEmailMobileMap[currentKey].push(rowData[i]);
    } else {
      uniqueEmailMobileMap[currentKey] = [rowData[i]];
    }
  }
  return uniqueEmailMobileMap;
};

export function isDifferentDate(d1: string, d2: string) {
  if (d1.length === 10) {
    const firstDate = new Date(convertDate(d1));
    const secondDate = new Date(convertDate(d2));

    return firstDate.getTime() !== secondDate.getTime();
  }
  return new Date(d1).getTime() !== new Date(d2).getTime();
}

export const sipAutoRenewalEnddateCalculator = (values: any) => {
  const rawFreq = values.sipFrequency || values.frequency || "";
  const freq = rawFreq.toUpperCase().charAt(0) as "M" | "Q"; 

  const multiplier = { M: 1, Q: 3 }[freq] || 1;
  const monthsToAdd = Number(values.noOfInstallments) * multiplier;

  const endDate = parse(values.endDate, 'dd/MM/yyyy', new Date());

  if (isNaN(endDate.getTime())) {
    console.error("Invalid endDate format", values.endDate);
    return null;
  }

  const requiredEndDate = addMonths(endDate, monthsToAdd);
  return format(requiredEndDate, 'dd/MM/yyyy');;
};


